// eslint-disable-next-line @nx/enforce-module-boundaries
import { type DeepLinkSchema } from '~/domains/platform/infra/deep-link/entities'

export const CREDIT_ROUTES = [
  '/credito',
  '/credito?abandon=1',
  '/emprestimo',
  '/emprestimo/proposta/simulacao',
  '/credito/emprestimo/proposta/simulacao',
  '/credito/emprestimo/proposta/atualizar-dados',
  '/credito/emprestimo/proposta/nacionalidade',
  '/credito/emprestimo/proposta/estado-civil',
  '/credito/emprestimo/proposta/endereco',
  '/credito/emprestimo/proposta/confirmar-dados',
  '/credito/emprestimo/proposta/revisao',
  '/credito/emprestimo/proposta/sucesso',
  '/credito/emprestimo/proposta/pin',
  '/credito/emprestimo/proposta/confirmar-pedido',
  '/credito/emprestimo/${loan}',
  '/credito/emprestimo/${loan}',
  '/credito/emprestimo/${loan}/antecipar-pagamento/${step}',
  '/credito/emprestimo/${loan}/antecipar-pagamento/inicio',
  '/credito/emprestimo/${loan}/parcela/${installment}',
  '/credito/emprestimo/${loan}/renegociacao',
  '/credito/emprestimo/${loan}/renegociacao/${step}',
  '/credito/emprestimo/${loan}/renegociacao/simulacao',
  '/credito/emprestimo/${loan}/renegociacao-parcelas',
  '/credito/emprestimo/${loan}/renegociacao-condicoes',
  '/credito/emprestimo/${loan}/emprestimo-original',
  '/credito/emprestimo/${loan}/emprestimo-original/parcela/${installment}',

  // Refinancing
  '/credito/emprestimo/renegociacao',
  '/credito/emprestimo/renegociacao/${step}',
  '/credito/emprestimo/renegociacao/condicoes',
  '/credito/emprestimo/renegociacao/condicoes?offerId=${offerId}',
  '/credito/emprestimo/renegociacao/simulacao',
  '/credito/emprestimo/renegociacao/simulacao?offerId=${offerId}',
  '/credito/emprestimo/renegociacao/proposta',
  '/credito/emprestimo/renegociacao/proposta?offerId=${offerId}&proposalId=${proposalId}',
  '/credito/emprestimo/renegociacao/dados-pessoais',
  '/credito/emprestimo/renegociacao/sucesso',
  '/credito/emprestimo/renegociacao/redirecionar/${type}',
  // Refinancing deeplinks replaced by deeplink[...path] hook
  '/credito/renegociacao/simulacao',
  '/credito/renegociacao/condicoes',
  '/credito/renegociacao/proposta/cliente',
  '/credito/renegociacao/proposta/stone',

  // Giro Fácil
  '/credito/limite-da-conta/${product}',
  '/credito/limite-da-conta/${product}/ddc/${withdrawalId}',
  '/credito/limite-da-conta/${product}/antecipar-pagamento/${step}',
  '/credito/limite-da-conta/${product}/saque/valor',
  '/credito/limite-da-conta/${product}/saque/sucesso',
  '/credito/limite-da-conta/${product}/contratacao/inicio',
  '/credito/limite-da-conta/${product}/contratacao/${step}',
  '/credito/limite-da-conta/${product}/demonstrativo',
  '/credito/limite-da-conta/${product}/antecipar-pagamento/inicio',
  '/credito/limite-da-conta/contratacao',
  '/credito/limite-da-conta/${product}/educacao/${slug}',

  // Building
  '/credito/construcao',
  '/credito/construcao/educacao',
  '/credito/construcao/educacao/${slug}',
  '/credito/construcao/transparencia',
  '/credito/construcao/transparencia/em-analise',
  '/credito/construcao/faturamento',
  '/credito/construcao/faturamento/atualizacao',
  '/credito/construcao/faturamento/atualizar-documentacao',
  '/credito/construcao/webview/gestao-de-limites',
  '/credito/construcao/webview/certidao-negativa-de-debitos',

  // Others
  '/roleta',
  '/credito/manutencao/${id}',
  '/credito/sdui/playground',
  '/credito/construtor-de-stories'
] as const

export const renegotiationBasePath = '/credito/emprestimo/${loan}/renegociacao'
export const refinancingBaseUrl = '/credito/emprestimo/renegociacao/'
export const refinancingBasePath = `${refinancingBaseUrl}\${step}`
export const refinancingAbandonQuery = 'abandon=1'
export const refinancingAbandonPath = `/credito?${refinancingAbandonQuery}`
export const loanConcessionBasePath = '/credito/emprestimo/proposta/simulacao'
export const revolvingCreditConcessionBasePath = '/credito/limite-da-conta/contratacao'
export const creditHomeBasePath = '/credito'

export const creditDeepLinks: { [key: string]: DeepLinkSchema } = {
  '/deeplink/credito/girofacil/oferta': {
    url: '/credito/limite-da-conta/contratacao',
    dependency: 'id',
    type: 'offers',
    product: 'revolving_credit',
    requiresLogin: true
  },
  '/deeplink/credito/girofacil/detalhe': {
    url: '/credito/limite-da-conta/${product}',
    dependency: 'id',
    type: 'products',
    product: 'revolving_credit',
    requiresLogin: true
  },
  '/deeplink/credito/girofacil/saque': {
    url: '/credito/limite-da-conta/${product}?isWithdrawalDrawerOpen=true',
    dependency: 'id',
    type: 'products',
    product: 'revolving_credit',
    requiresLogin: true
  },
  '/deeplink/credito/capitaldegiro/oferta': {
    url: '/emprestimo/proposta/simulacao',
    product: 'loans',
    dependency: 'id',
    type: 'offers',
    requiresLogin: true
  },
  '/deeplink/emprestimo': {
    url: '/emprestimo',
    product: 'loans',
    type: 'products',
    requiresLogin: true
  },
  '/deeplink/credito': {
    url: '/credito',
    product: 'credit',
    type: 'products',
    requiresLogin: true
  },
  /**
   * These deep links below are not handled by pages/deeplink/[…path].tsx, due to refinancing architecture.
   * Instead, they are initially handled by the Next.js router for permanent redirection.
   * When a logout obligation is encountered, ir reads these declarations and
   * directs the user to the login page (if they are not already authenticated) with the appropriate redirect URL.
   * The parameters other than requiresLogin are useless.
   */
  '/credito/emprestimo/renegociacao/redirecionar/proposta/cliente': {
    url: '/credito/emprestimo/renegociacao/redirecionar/proposta/cliente',
    product: 'loans',
    type: 'offers',
    requiresLogin: true
  },
  '/credito/emprestimo/renegociacao/redirecionar/proposta/stone': {
    url: '/credito/emprestimo/renegociacao/redirecionar/proposta/stone',
    product: 'loans',
    type: 'offers',
    requiresLogin: true
  },
  '/credito/emprestimo/renegociacao/redirecionar/condicoes': {
    url: '/credito/emprestimo/renegociacao/redirecionar/condicoes',
    product: 'loans',
    type: 'offers',
    requiresLogin: true
  },
  '/credito/emprestimo/renegociacao/redirecionar/simulacao': {
    url: '/credito/emprestimo/renegociacao/redirecionar/simulacao',
    product: 'loans',
    type: 'offers',
    requiresLogin: true
  }
}
